import Collection, { getDefaultCollection } from "../model/Collection";
import { getUid } from "../../auth/AuthManager";
import getApiInstance from "../../common/api";
import OnevocaServerError from "../../common/OnevocaServerError";

export async function deleteCollection(collectionId: number): Promise<void> {
  try {
    const uid = await getUid();
    const parameters = {
      uid: uid,
      collectionId: collectionId,
    };

    const response = await getApiInstance(undefined).post(
      "/collection/deleteCollection.php",
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    } else {
      return;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function patchCollectionName(
  collectionId: number,
  newCollectionName: string
): Promise<void> {
  try {
    const uid = await getUid();
    const parameters = {
      uid: uid,
      collectionId: collectionId,
      newCollectionName: newCollectionName,
    };

    const response = await getApiInstance(undefined).post(
      "/collection/renameCollection.php",
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    } else {
      return;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function putColletion(collectionName: string): Promise<void> {
  try {
    const uid = await getUid();
    const parameters = {
      uid: uid,
      collectionName: collectionName,
    };
    const response = await getApiInstance(undefined).post(
      "/collection/addCollection.php",
      parameters
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    } else {
      return;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function fetchCollectionList(
  withDefaultCollection: boolean
): Promise<Collection[]> {
  try {
    const uid = await getUid();

    const response = await getApiInstance(undefined).get(
      `/collection/getCollectionList.php?uid=${uid}`
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    }

    const result = response.data.result;
    if (result === undefined) {
      return Promise.reject("No data.");
    }

    const collections = result.collections.map((collection: any) =>
      Collection.fromJson(collection)
    );

    const groupCount = result.groupTotalCount ?? 0;
    if (withDefaultCollection) {
      collections.unshift(getDefaultCollection(groupCount));
    }

    return collections;
  } catch (error) {
    return Promise.reject(error);
  }
}
